import { Component, OnInit, Inject } from '@angular/core';
import { Folder } from '../../models/folder.model';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface FolderGestorDialogData {
  folders: Folder[];
  selectedFolder: string;
}
@Component({
  selector: 'app-folder-gestor',
  templateUrl: './folder-gestor.component.html',
  styleUrls: ['./folder-gestor.component.scss']
})
export class FolderGestorComponent implements OnInit {

  public folders: Folder[];
  public pathFolders = [];
  public currentFolder = null;
  public currentFolders = null;
  public selectedFolder = null;
  folderform: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<FolderGestorComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: FolderGestorDialogData) {
      this.folders = this.dataDialog.folders ? this.dataDialog.folders : [];
      this.selectedFolder = this.dataDialog.selectedFolder ? this.dataDialog.selectedFolder : null;
      this.currentFolder = this.dataDialog.selectedFolder ? this.folders.find(fi => fi.i === this.dataDialog.selectedFolder ).p : null;
      this.updateFolderTree();
    }
    updateFolderTree() {
      this.currentFolders = this.folders.filter(fi => fi.p === this.currentFolder);
      this.updatePath();
    }
    ngOnInit(): void {
    }
    cancel(): void {
      this.dialogRef.close();
    }
    isParent(folder) {
      return this.folders.filter(fi => fi.p === folder.i).length > 0;
    }
    updatePath() {
      this.pathFolders = [];
      let fi = this.folders.find(fii => fii.i === this.currentFolder);
      while (fi) {
        this.pathFolders.push(fi);
        fi = this.folders.find(fii => fii.i === fi.p);
      }
      this.pathFolders = this.pathFolders.reverse();
    }
}
